import { tDrawerSeparatorsLib } from '@/Interfaces/caseComponentsLib';

export const drawerSeparators: tDrawerSeparatorsLib = [
    {
        id: 'tc_125',
        xmlId: '2a335ce4-9be3-1ef1-0b73-f5b4a689a956',
        name: 'Комплект перегородок AMH TC 60/125 (разделитель для ящика)',
        type: 'drawerSeparator',
        blenderName: 'partition_amh_tc_125',
        image: 'dist/src/img/AMH-TC-60-125.png',
        applicableDrawerIds: [ 'amh_tc_125' ],
    },
    {
        id: 'tc_60',
        xmlId: '2a335ce4-9be3-1ef1-0b73-f5b4a689a956',
        name: 'Комплект перегородок AMH TC 60/125 (разделитель для ящика)',
        type: 'drawerSeparator',
        blenderName: 'partition_amh_tc_60',
        image: 'dist/src/img/AMH-TC-60-125.png',
        applicableDrawerIds: [ 'amh_tc_60' ],
    },
    {
        id: 'part_hard_60',
        xmlId: 'be5ef289-cbe7-859f-293e-bdee6ec10aa8',
        name: 'Комплект перегородок HARD 60',
        type: 'drawerSeparator',
        blenderName: 'partition_hard_60',
        image: 'dist/src/img/AMH-TC-60-125.png',
        applicableDrawerIds: [ 'dr_hard_60' ],
    },
    {
        id: 'part_hard_125',
        xmlId: '98db9bc2-ece1-d136-872d-3fc56ad41768',
        name: 'Комплект перегородок HARD 125',
        type: 'drawerSeparator',
        blenderName: 'partition_hard_125',
        image: 'dist/src/img/AMH-TC-60-125.png',
        applicableDrawerIds: [ 'dr_hard_125' ],
    },
];
